import React, { ReactElement } from 'react';
import styles from './typingIndicator.module.scss';

const TypingIndicator = (): ReactElement => {
    return (
        <div className={styles['typing-indicator-container']}>
            <div className={styles['typing-bubble']}>
                <div className={styles.dot}></div>
                <div className={styles.dot}></div>
                <div className={styles.dot}></div>
            </div>
        </div>
    );
};

export default TypingIndicator;
